module.exports = __webpack_public_path__ + "img/google-pay-mark_800.2cb08d65.svg";